import {computed} from "vue";
import {useWords} from "./useWords.js";
import {useUserState} from "./useUserState.js";

// The default backend for useGameEngine: the real daily game. Wraps the server-backed
// useWords calls and the persisted UserState so the engine itself stays free of transport
// and persistence details (the archive practice mode swaps in a local, no-op adapter).
export const useLiveAdapter = () => {
    const {currentWords, getWords, loading: loadingWords, completedWords, over, makeGuess} = useWords();
    const {syndleUser, createUser, loading: loadingUser} = useUserState();

    return {
        currentWords,
        loading: computed(() => loadingUser.value || loadingWords.value),
        // Re-pull authoritative state from the server before each (re)init. The live Game
        // remounts when returning from an archive run, and syndleUser is otherwise only a
        // load-time snapshot, so without this the board would show stale progress
        // (e.g. a finished day looking unplayed).
        async refresh() {
            await createUser();
        },
        initialState() {
            return {
                score: syndleUser.value.game,
                hearts: syndleUser.value.hearts,
                over: syndleUser.value.over,
                guessedLetters: syndleUser.value.guessedLetters,
                xp: syndleUser.value.xp,
                momentum: syndleUser.value.momentum,
            };
        },
        loadWords: getWords,
        completed: completedWords,
        gameOver: over,
        recordGuess: makeGuess,
    };
};
